const $page = document.querySelector('.page')
const $pageScrollSignifier = document.querySelector('.page-scroll-signifier')

if ($pageScrollSignifier) {
	$pageScrollSignifier.addEventListener('click', () => {
		window.scrollBy({ top: window.innerHeight * 0.75 })
	})
}

if ($page || $pageScrollSignifier) {
	window.addEventListener('scroll', handleScroll, { passive: true })
	window.addEventListener('resize', handleScroll, { passive: true })
	handleScroll()
}

function handleScroll() {
	if ($page) {
		const opacity = Math.max(0, 1 - (window.scrollY / (window.innerHeight / 2)))
		$page.style.setProperty('--page-bg-opacity', opacity.toFixed(2))
	}

	if ($pageScrollSignifier) {
		$pageScrollSignifier.hidden = window.scrollY > 0
	}
}
